import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/BreadCrumb/breadCrumb';
import Strings from '../../../constants/stringConstant';
import Path from '../../../constants/path';
import sharedStyles from '../Masters.module.css';
import { Box, Grid, IconButton } from '@mui/material';
import SearchBox from '../../../components/SearchBox/searchBox';
import ButtonComp from '../../../components/Button/buttonComp';
import { ReactComponent as AddIcon } from '../../../assets/images/addIconWhite.svg';
import PaginationComp from '../../../components/Pagination/paginationComp';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import AddEditEmailTemplateMaster from './AddEditEmailTemplateMaster';
import { toast } from 'react-toastify';
import makeApiCall from '../../../api/makeApiCall';
import SuccessModal from '../../../components/Modal/successModal';
import { ReactComponent as EditSharpIcon } from '../../../assets/images/editIcon.svg';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import { useSelector } from 'react-redux';
import { upsertEmailTemplate, fetchEmailTemplateMaster } from '../../../api/request/masterFetchApi/masterFetchApi';

function EmailTemplateMaster() {
    const paths = [
        {
            name: Strings.masters.masters,
            link: Path.email_template_master,
        },
        { name: Strings.masters.email_template_master, link: '' },
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [addEditEmailTemplateModal, setAddEditEmailTemplateModal] = useState(false);
    const [type, setType] = useState('add');
    const [selectedRowObject, setSelectedRowObject] = useState({});
    const [totalPages, setTotalPages] = useState(0);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [noRecordsFound, setNoRecordsFound] = useState(false);
    const [failedModal, setFailedModal] = useState(false);
    const { roleBased } = useSelector(state => state.rbacValue);
    const isEditEmailTemplate = roleBased?.masters?.sections?.email_template_master !== 'edit';
    const rowPerTable = 10;

    function toggleEmailTemplateModal() {
        setAddEditEmailTemplateModal(!addEditEmailTemplateModal);
    }

    useEffect(() => {
        fetchEmailTemplateMasterApi();
    }, [searchQuery, currentPage]);

    useEffect(() => {
        if (successModal) {
            setTimeout(() => {
                handleSuccessModal();
            }, 2000);
        }
    }, [successModal]);

    useEffect(() => {
        if (failedModal) {
            setTimeout(() => {
                handleFailedModal();
            }, 2000);
        }
    }, [failedModal]);

    const handleApiError = response => {
        toast.error(response?.data?.error?.errorMessage, { position: 'top-right' });
    };

    const fetchEmailTemplateMasterApi = async () => {
        setLoading(true);
        try {
            const requestPayload = {
                pageNumber: currentPage - 1,
                pageSize: rowPerTable,
                searchTerm: searchQuery,
            };
            const response = await makeApiCall(fetchEmailTemplateMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                const data = response?.data?.data?.content ?? [];
                setRows(data);
                setTotalPages(
                    Math.ceil(response?.data?.data?.totalElements / rowPerTable),
                );
                if (data?.length === 0) {
                    setNoRecordsFound(true);
                } else {
                    setNoRecordsFound(false);
                }
            } else {
                handleApiError(response);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const upsertEmailTemplateApi = async (data) => {
        setLoading(true);
        try {
            const requestPayload = {
                id: data?.id || 0,
                vendorType: data?.vendorType,
                parallelWorkflowId: data?.parallelWorkflowId || 0,
                subject: data?.subject ?? '',
                htmlTemplate: data?.htmlTemplate ?? '',
                status: data?.status ?? true,
            };
            const response = await makeApiCall(upsertEmailTemplate(requestPayload));
            if (response?.data?.status === Strings?.success) {
                setSuccessModal(true);
                fetchEmailTemplateMasterApi();
            } else {
                handleApiError(response);
                setFailedModal(true);
                setSuccessModal(false);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const loanColumns = [
        { label: 'Vendor Type', field: 'vendorType' },
        { label: 'Subject', field: 'subject' },
        { label: 'HTML Template', field: 'htmlTemplate' },
    ];

    const handleSearch = query => {
        setSearchQuery(query);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSuccessModal = () => {
        setSuccessModal(false);
    };

    const handleFailedModal = () => {
        setFailedModal(false);
    };

    return (
        <Box className={sharedStyles.main_container}>
            <Breadcrumb paths={paths} />
            <Box className={sharedStyles.secondary_container}>
                <Grid
                    container
                    sx={{
                        gap: '12px',
                        justifyContent: 'space-between',
                    }}>
                    <Grid item>
                        <SearchBox searchQuery={searchQuery} onSearch={handleSearch} />
                    </Grid>
                    <Grid item>
                        <Grid
                            container
                            sx={{
                                gap: '12px',
                            }}>
                            <ButtonComp
                                type="submit"
                                className="text-bold-16px"
                                endIcon={<AddIcon />}
                                value={Strings.masters.add_new}
                                gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                                height="40px"
                                padding="14px 24px"
                                textcolor="#fff"
                                borderRadius="8px"
                                onClick={() => {
                                    setType('add');
                                    toggleEmailTemplateModal();
                                }}
                                disabled={isEditEmailTemplate}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableComp
                    loader={loading}
                    columns={loanColumns}
                    rows={rows}
                    editDisabled={isEditEmailTemplate}
                    handleActionClick={row => {
                        setType('edit');
                        toggleEmailTemplateModal();
                        setSelectedRowObject(row);
                        fetchEmailTemplateMasterApi();
                    }}
                    showTotal={false}
                    firstColumnBgColor={'white'}
                    noRecordsFound={noRecordsFound}
                    actionIcon={
                        <IconButton aria-label="close" disabled={isEditEmailTemplate}>
                            <EditSharpIcon />
                        </IconButton>
                    }
                />
                {totalPages > 0 && !noRecordsFound && (
                    <PaginationComp
                        totalPages={totalPages}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                )}
            </Box>
            {addEditEmailTemplateModal && (
                <ModalwithButton
                    open={addEditEmailTemplateModal}
                    message={type === 'add' ? 'Add Email Template' : 'Edit Email Template'}
                    subMessage={
                        'Fill in the below details to add them to the master table'
                    }
                    leftRenderWithoutPadding
                    bolderHeadings
                    subMessageColor={'#475467'}
                    onClose={toggleEmailTemplateModal}
                    minWidth={'50%'}>
                    <AddEditEmailTemplateMaster
                        closeModal={toggleEmailTemplateModal}
                        selectedRowObject={selectedRowObject}
                        type={type}
                        upsertEmailTemplateApi={upsertEmailTemplateApi}
                        selectedVendors={rows?.map(item => item?.vendorType)}
                    />
                </ModalwithButton>
            )}
            <SuccessModal
                open={successModal}
                onClose={handleSuccessModal}
                message={
                    type === 'add'
                        ? Strings.masters.added_record
                        : Strings.masters.updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.added_record_des
                        : Strings.masters.updated_record_des
                }
            />
            <SuccessModal
                open={failedModal}
                onClose={handleFailedModal}
                message={
                    type === 'add'
                        ? Strings.masters.failed_added_record
                        : Strings.masters.failed_updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.failed_added_record_des
                        : Strings.masters.failed_updated_record_des
                }
                reject
            />
        </Box>
    );
}

export default EmailTemplateMaster;
